import { GovernedIntelligenceDashboard } from "@/components/GovernedIntelligenceDashboard";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/financial-intelligence")({
  head: () => ({
    meta: [
      { title: "Financial Intelligence — Broadview Warranty Intelligence" },
      {
        name: "description",
        content:
          "Governed exposure and cost-of-delay scenarios with explicit financial classifications and provenance.",
      },
    ],
  }),
  component: FinancialIntelligencePage,
});

function FinancialIntelligencePage() {
  return <GovernedIntelligenceDashboard view="financial-intelligence" />;
}
